export class User {
  constructor(id?: string,  name?: string, email?: string,IsBhavan?:boolean,permissions?:any,unit?:any,postion?:any,unitId?:any,postionId?:any,orgId?:any,IsAllowCreate?:boolean,IsUnitEnabled?:boolean,) {
    this.id = id;
    this.email = email;
    this.IsBhavan=IsBhavan
    this.name=name
    this.permissions=permissions
    this.postion=postion
    this.unit=unit
    this.unitId=unitId,
    this.positionId=postionId
    this.orgId=orgId
    this.IsAllowCreate=IsAllowCreate,
    this.IsUnitEnabled=IsUnitEnabled
  }
  public id: string;
  public name: string;
  public email: string;
  public IsBhavan:boolean;
  public permissions:any;
  public postion:any;
  public unit:any;
  public positionId:string;
  public unitId:string;
  public orgId:string;
  public IsAllowCreate:boolean;
  public IsUnitEnabled:boolean;
}
